import React from 'react';
import { useI18n } from '../../i18n/I18nContext';

/**
 * LanguageSwitch — the UZ | EN | RU buttons, in that order everywhere (spec §5). One component for
 * the top bar, the phone drawer and the sign-in pages, which differ only in how they look: the
 * caller passes the classes of its own skin.
 *
 *   <LanguageSwitch className="tb-lang" buttonClassName="tb-lang-btn" />
 *   <LanguageSwitch className="auth-lang" buttonClassName="auth-lang-btn" label={t('auth.language')} />
 *
 * It renders a `role="group"` named "Til" with one button per language (`aria-pressed`, the
 * language's own name as `title`, `lang` set so a screen reader pronounces it). Only the user's own
 * click changes the language: the choice is stored by the I18nProvider (`crm-lang`).
 *
 * Props: className (the group), buttonClassName (every button), activeClassName (added to the
 * current one, default `is-active`), label (the group's accessible name; default
 * `topbar.language`).
 */
function LanguageSwitch({ className = '', buttonClassName = '', activeClassName = 'is-active', label }) {
  const { t, lang, setLang, languages } = useI18n();
  return (
    <div className={className || undefined} role="group" aria-label={label || t('topbar.language')}>
      {languages.map((item) => {
        const current = item.code === lang;
        return (
          <button
            key={item.code}
            type="button"
            lang={item.code}
            className={[buttonClassName, current ? activeClassName : ''].filter(Boolean).join(' ') || undefined}
            aria-pressed={current}
            title={item.label}
            onClick={() => setLang(item.code)}
          >
            {item.short}
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitch;
